import { render } from "./NewsApp.vue?vue&type=template&id=cdc340fa"
import script from "./NewsApp.vue?vue&type=script&lang=js"
export * from "./NewsApp.vue?vue&type=script&lang=js"

import "./NewsApp.vue?vue&type=style&index=0&id=cdc340fa&lang=css"

import exportComponent from "/home/nimens/projects/cafe-portos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__